import axios from "axios";

import { config } from "shared/data";

import type { QuizSubmission, QuizSubmissionInput } from "scmp-app/components/posties/quiz/types";

import { GetQuizById } from "./consts";
import type { QuizData } from "./types";

export const getQuizData = async (form: { documentId: string; email: string }) => {
  const { documentId, email } = form;

  const formData = await axios.post<{
    data: {
      getFormByEmail: null | QuizData;
    };
  }>(
    config.graphql.studentService.host,
    {
      query: GetQuizById,
      variables: {
        documentId,
        email,
      },
    },
    {
      headers: {
        apiKey: config.graphql.studentService.apiKey,
        "Content-Type": "application/json",
      },
    },
  );

  const getFormByEmail = formData.data?.data?.getFormByEmail;

  return getFormByEmail;
};

export const submitQuiz = async ({ answers, email, formId }: QuizSubmissionInput) => {
  const response = await axios.post<{
    data: { createSubmission: QuizSubmission };
  }>(
    config.graphql.studentService.host,
    {
      query: `
              mutation CreateSubmission($input: SubmissionInput!) {
                createSubmission(input: $input) {
                  success
                  questionReport {
                    questionId
                    isCorrect
                    correctAnswers
                  }
                }
              }
            `,
      variables: {
        input: {
          answers,
          email,
          formId,
          skipKey: config.graphql.studentService.skipKey,
        },
      },
    },
    {
      headers: {
        apiKey: config.graphql.studentService.apiKey,
        "Content-Type": "application/json",
      },
    },
  );

  return response.data?.data?.createSubmission ?? null;
};
